import { watch, ref, onUnmounted, reactive } from 'vue'
import { useFormStore } from '@/stores/form'
import lookups from '@/assets/json/clientLookups.json'
import apiHelperService from '@/services'
const relationshipWatch = () => {
  const relationshipIdWatch = ref()
  const formStore = useFormStore()
  const {
    relationships: { daughter, son }
  } = lookups
  relationshipIdWatch.value = watch(
    () => formStore.form.values.sponsorRelationshipId,
    async (newVal) => {
      if (newVal) {
        const cachedData = await apiHelperService.get('/api/lookup/GetFamilyRelations')
        if (cachedData) {
          let curObj = cachedData.find((item) => item.id == newVal)
          const { genderId } = curObj
          formStore.form.setFieldValue('genderId', genderId)
        }
        if (![daughter, son].includes(newVal)) {
          formStore.draft.request = {
            ...formStore.draft.request,
            fatherUnifiedNumber: null,
            fatherEID: null,
            fatherEnglishFullName: null,
            fatherArabicFullName: null,
            fatherDateOfBirth: null,
            fatherPassportNumber: null,
            fatherNationalityId: null,

            motherUnifiedNumber: null,
            motherEID: null,
            motherEnglishFullName: null,
            motherArabicFullName: null,
            motherDateOfBirth: null,
            motherPassportNumber: null,
            motherNationalityId: null
          }
        }
      }
    }
  )
  onUnmounted(() => {
    relationshipIdWatch.value && relationshipIdWatch.value()
  })
}

const genderWatch = () => {
  const genderIdWatch = ref()
  const formStore = useFormStore()
  const {
    gender: { male },
    professions: { child, femaleChild }
  } = lookups
  genderIdWatch.value = watch(
    () => formStore.form.values.genderId,
    async (newVal) => {
      if (newVal) {
        formStore.form.setFieldValue('professionId', femaleChild)
        if (newVal == male) {
          formStore.form.setFieldValue('professionId', child)
        }
      }
    }
  )
  onUnmounted(() => {
    genderIdWatch.value && genderIdWatch.value()
  })
}

export default function () {
  return {
    relationshipWatch,
    genderWatch
  }
}
